import React, { Component } from 'react';
import { Row, Col } from 'antd';

import { Link } from 'react-router-dom';

import LayoutWrapper from '../UI/LayoutWrapper';
import PageHeader from '../UI/PageHeader';
import Box from '../UI/Box';

class OrdersNewSuccess extends Component {
  render() {
    return (
      <LayoutWrapper>
        <PageHeader>Bestelling geplaatst</PageHeader>
        <Row
          style={{
            width: '100%',
            display: 'flex',
            flexFlow: 'row wrap',
          }}
          gutter={24}
          justify="start"
        >
          <Col
            md={42}
            sm={24}
            xs={24}
            style={{ marginBottom: '16px' }}
          >
            <Row
              style={{
                width: '100%',
                display: 'flex',
                flexFlow: 'row wrap',
                textAlign: 'center',
                fontSize: '14px',
                lineHeight: '40px',
              }}
              gutter={0}
              justify="start"
            >
              <Col
                md={24}
                sm={24}
                xs={24}
                style={{ marginBottom: '16px' }}
              >
                <Box>
                  <h2>Bedankt voor uw bestelling!</h2>
                  <p>Uw bestelling wordt zo snel mogelijk verwerkt.</p>
                  <Link to="/">Terug naar de homepagina</Link>
                </Box>
              </Col>
            </Row>
          </Col>
        </Row>
      </LayoutWrapper>
    );
  }
}

export default OrdersNewSuccess;


// WEBPACK FOOTER //
// ./src/components/Orders/OrdersNewSuccess.js